import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration  } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus , InteractionType, PopupRequest, RedirectRequest} from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { LoginService } from './services/login-service';
import { filter, Subject, takeUntil } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router'; 
import { HeaderComponent } from './login-home/header/header.component';
import { FooterComponent } from './login-home/footer/footer.component';
import { SidenavComponent } from './login-home/sidenav/sidenav.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [CommonModule,RouterOutlet, HeaderComponent,FooterComponent,SidenavComponent]
})
export class AppComponent implements OnInit,OnDestroy {
  title = 'ROAR APP';
  isIframe = false;
  loginDisplay = false;
  envBoxText = '';
  envBoxBG = '';
  // accountinfo =[];
  username = '';
  private readonly _destroying$ = new Subject<void>();

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig:MsalGuardConfiguration,
                                         private msalBroadcastService:MsalBroadcastService, 
                                        private authService: MsalService,
                                        // private http: HttpClient,
                                        private loginService: LoginService ,
                                        private titleService: Title
  ) { }

 ngOnInit() {
    this.envBoxText = environment.Settings.EnvironmentBoxText;
    this.envBoxBG = environment.Settings.EnvironmentBoxBG;
    this.titleService.setTitle(`ROAR-${environment.defaultenv}`);
 
    this.isIframe = window !== window.parent && !window.opener;
    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status:InteractionStatus) => status == InteractionStatus.None),
        takeUntil(this._destroying$)
    )
    .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
        const activeAccount = this.authService.instance.getActiveAccount();
        if (activeAccount && activeAccount.idTokenClaims) {
          this.getClaims(activeAccount.idTokenClaims);
        }
        this.loginService.LoginROARAPI().subscribe({
          next: (result) => {        
        },
        error: (err: any) => {
                //  this.spinner.hide();
        },
        complete: () => {
                  //  this.spinner.hide(); 
        }  
    });;
    });
    

  }


  checkAndSetActiveAccount() {
    const activeAccount = this.authService.instance.getActiveAccount();
    const allAccounts = this.authService.instance.getAllAccounts();

    if (!activeAccount && allAccounts.length > 0) {
      this.authService.instance.setActiveAccount(allAccounts[0]);
    }
  }

getClaims(claims: any) {
    if (!claims || !claims['preferred_username']) {
      return;
    }
    const getName = claims['name'] || '';
    const username = claims['preferred_username'];
    const user = {
      displayName: getName,
      eid: username.substring(0, username.indexOf('@')),
      email: username,
      roles: Object.assign([], claims.roles),
    };
    this.loginService.user = user;
  }

login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      const popupRequest = this.msalGuardConfig.authRequest
        ? ({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        : undefined;
      this.authService.loginPopup(popupRequest).subscribe((response: AuthenticationResult) => {
        this.authService.instance.setActiveAccount(response.account);
      });
    } else {
      const redirectRequest = this.msalGuardConfig.authRequest
        ? ({ ...this.msalGuardConfig.authRequest } as RedirectRequest)
        : undefined;
      this.authService.loginRedirect(redirectRequest);
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;  
  }

  ngOnDestroy():void{
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
